import {
    STATUS_APPROVED,
} from "@/constants/audit";
import {getIndustryName, getScaleName, getStageName, salaryMultipleName} from "@/utils/job";
import {getRefereeStatusName} from "@/utils/referee";
import {fen2KYuan} from "@/utils/money";

export default class JdReferee {

    constructor(options) {
        this._id = options?._id || 0

        // from jd referee
        this.jdId = options?.jdId || 0
        this.jdUserId = options?.jdUserId || 0
        this.refereeId = options?.refereeId || 0
        this.refereeUserId = options?.refereeUserId || 0
        this.statusId = options?.statusId || 0
        this.statusText = options?.statusText || "-"
        //this.statusShort = refereeStatusShort(this.statusId)
        this.statusShort = getRefereeStatusName(this.statusId)
        this.isApproved = this.statusId == STATUS_APPROVED
        this.isNew = this._id <= 0

        // from referee user
        this.userId = options?.referee?.userId || 0
        this.companyId = options?.referee?.companyId || 0
        this.department = options?.referee?.department || ""
        this.jobTitle = options?.referee?.jobTitle || ""
        this.companyEmail = options?.referee?.companyEmail || ""
        this.emailAuthCode = options?.referee?.emailAuthCode || ""
        this.introduction = options?.referee?.introduction || ""

        this.refereeStatusId = options?.referee?.statusId || 0
        this.refereeStatusText = options?.referee?.statusText || "-"
        //this.refereeStatusShort = refereeStatusShort(this.refereeStatusId)
        this.refereeStatusShort = getRefereeStatusName(this.refereeStatusId)

        // from user
        this.userLogo = options?.user?.avatarUrl || ""
        this.userName = options?.user?.name || ""

        // from service
        this.serviceChatType = options?.service?.chatType || 0
        this.serviceCvReview = options?.service?.cvReview || 0
        this.serviceInterview = options?.service?.interview || 0
        this.serviceItvCvReview = options?.service?.itvCvReview || 0
        this.serviceCareerPlanning = options?.service?.careerPlanning || 0

        // from jd
        this.jdTitle = options?.jd?.title || ""
        this.jdKeyWords = options?.jd?.keyWords || ""
        this.jdWelfares = options?.jd?.welfares || ""
        this.jdSalaryFromName = fen2KYuan(options?.jd?.salaryFrom) || ""
        this.jdSalaryToName = fen2KYuan(options?.jd?.salaryTo) || ""
        this.jdSalaryMultipleName = salaryMultipleName(options?.jd?.salaryMultiple) || ""
        this.jdSalaryRange = this.jdSalaryFromName +"-"+ this.jdSalaryToName +" * "+ this.jdSalaryMultipleName
        this.jdDesc = options?.jd?.desc || ""

        // from jd company
        this.companyFullName = options?.jd?.company?.fullName
        this.companyNickName = options?.jd?.company?.nickName
        this.companyLogoKey  = options?.jd?.company?.logoKey
        this.companyLogoUrl  = options?.jd?.company?.logoUrl
        this.companyIndustryId = options?.jd?.company?.industryId
        this.companyIndustryName = getIndustryName(this.companyIndustryId)
        this.companyIndustryId2 = options?.jd?.company?.industryId2
        this.companyIndustryName2 = getIndustryName(this.companyIndustryId2)
        this.companyIndustryId3 = options?.jd?.company?.industryId3
        this.companyIndustryName3 = getIndustryName(this.companyIndustryId3)
        this.companyScaleId  = options?.jd?.company?.scaleId
        this.companyScaleName = getScaleName(this.companyScaleId)
        this.companyStageId  = options?.jd?.company?.stageId
        this.companyStageName = getStageName(this.companyStageId)

        this.companyIndustryNames = [this.companyIndustryName,
            this.companyIndustryName2,
            this.companyIndustryName3]
            .filter(function (s) {
                return s && s.trim()
            }).join(",")
    }

    toJSON () {
        return { ...this }
    }
}
